import { useMemo } from 'react';
import {createLinearModeDataSelector} from './calculateLinearModeData';
import {useStudentSelector} from '../../../store/selectors/useStudentSelector';

export const useLinearModeDataSelector = (isLinearMode: boolean) => {
  const selector = useMemo(() => createLinearModeDataSelector(isLinearMode), [isLinearMode]);
  return useStudentSelector(selector);
};
